import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormGroup, FormLabel, IconButton, MenuItem, Modal, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import TitleText from './TitleText'
import CancelIcon from '@mui/icons-material/Cancel';
import ButtonStyled from './ButtonStyled';
import { getProductsAll } from '../services/productService';
import  { v4 as uuidv4 } from 'uuid';

import CheckIcon from '@mui/icons-material/Check';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import PublishIcon from '@mui/icons-material/Publish';

import { enqueueSnackbar } from 'notistack';
import DeleteModal from './DeleteModal';
import { productVariantsCreate, productVariantsGenerate } from '../services/productVariantsService';
import CharacteristicDependencyValuesTable from './CharacteristicDependencyValuesTable';
import CharacteristicDependencyRuleForm from './CharacteristicDependencyRuleForm';
import CharacteristicDependencyRuleModifiers from './CharacteristicDependencyRuleModifiers';
import ProductVariantSummary from './ProductVariantSummary';
import CharacteristicDependencyPriceCSV from './CharacteristicDependencyPriceCSV';
import { useRef } from 'react';
import { escapeComma } from '../utils/utils';


const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "80vw",
    bgcolor: 'background.paper',
    borderRadius: '0.25rem',
    boxShadow: 24,
    pt: '1.125rem',
    pb: '2.5rem',
    flexGrow: 1,
    '&:focus-visible': { outline: 0},
};
const formLabelStyle = {color: '#A1A1A1', fontWeight:'bold', fontSize:{xs: '1rem',}, display: 'flex', pb:'0.6rem' };


const tabs = [
    {step: 1, title: "Características"},
    {step: 2, title: "Dependencias"},
    {step: 3, title: "Dimensiones"},
    {step: 4, title: "Resumen"},
]


function CharacteristicDependencyModal({
    itemToEdit,
    onConfirmed, 
    openModal, 
    onCloseModal
}) {

    const [dependencyForm, setDependencyForm] = useState({
        productId: "",
        base_price: 0.0,
        dependencyRules: [],
        characteristics: [],
        isPublished: false
    })

    const [baseProducts, setBaseProducts] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const { productId, dependencyRules, characteristics } = dependencyForm
    const [ enabledCharacteristics, setEnabledCharacteristics ] = useState([])

    const [primaryCharacteristic, setPrimaryCharacteristic] = useState({
        primaryCharacteristicName: "",
        primaryCharacteristicValues: [],
        primaryCharacteristicCode: "",
        primary: true,
        primaryCharacteristicCategory: ""
    })

    const [sharedPriceModifier, setSharedPriceModifier] = useState(0.0);
    const [sharedWeightModifier, setSharedWeightModifier] = useState(0.0);
    const [sharedDepth, setSharedDepth] = useState(0.0);
    const [sharedWidth, setSharedWidth] = useState(0.0);
    const [sharedHeight, setSharedHeight] = useState(0.0);

    const [ variantMatrix, setVariantMatrix ] = useState([]) 
    const [ characteristicActions, setCharacteristicActions ] = useState([])
    const variantMatrixRef = useRef(variantMatrix)
    const [ variantMatrixRefVersion, setVariantMatrixRefVersion ] = useState(0)

    const { primaryCharacteristicName, primaryCharacteristicValues, primaryCharacteristicCategory } = primaryCharacteristic

    const [ activeTab, setActiveTab ] = useState(1)
    const [ currSelectedRule, setCurrSelectedRule ] = useState("")

    const [ openDeleteModal, setOpenDeleteModal ] = useState(false)
    const [ openConfirmModal, setOpenConfirmModal ] = useState(false)
    const [ openPublishModal, setOpenPublishModal ] = useState(false)
    const [confirmPublished, setConfirmPublished ] = useState(false)

    const [ isDataLoaded, setIsDataLoaded ] = useState(false)
    
    const [ deleteContext, setDeleteContext ] = useState({
        type: null,
        payload: null
    })

    let autoSaveIntervalIdRef = useRef(null)
    
    // Ref to hold the latest autoSave function (avoids stale closure in interval)
    const autoSaveRef = useRef(null)

    // Define autoSave first (will be kept fresh via ref)
    const autoSave = async (overrideData = null) => {
        // Ignore flags if overrideData is provided
        if (!overrideData && (isLoading || !openModal || !isDataLoaded)) return;

        try {
            const formData = overrideData || processProductConfig(); // always reads latest state/refs

            const resp = await productVariantsCreate({...formData, isPublished: false});

            if (resp.result) {
                enqueueSnackbar(
                    "Cambios guardados automáticamente. Próxima actualización en 2 minutos.",
                    { variant: "success" }
                );
            } else {
                console.error("Error on autosave", resp);
            }
        } catch (e) {
            console.error("Error on autosave", e);
        }
    };

    // Always keep autoSaveRef.current pointing to the latest autoSave function
    useEffect(() => {
        autoSaveRef.current = autoSave;
    });

    // Autosave useEffect every 2 minutes
    useEffect(() => {
        if (!openModal || !isDataLoaded) return;
    
        // Call the ref's current value so we always use the latest autoSave
        autoSaveIntervalIdRef.current = setInterval(() => {
            autoSaveRef.current?.();
        }, 120_000);
        
        return () => clearInterval(autoSaveIntervalIdRef.current)
    }, [openModal, isDataLoaded]); // only re-start autosave when modal opens/closes

    useEffect(() => {
        if (itemToEdit && baseProducts.length > 0) {
            preSetForm();
        }
    }, [itemToEdit, baseProducts]);

    useEffect(() => {
        const init = async () => {
            await loadBaseProducts();
        };
        init();
    }, []);

    const preSetForm = async () => {
        // console.log("PRESET", itemToEdit)

        if (!itemToEdit || isLoading) return;

        setIsLoading(true)
        setIsDataLoaded(false)

        // console.log("ITEM CHARS", itemToEdit.characteristics)
        let loadedData = handleBaseProductChange({ target: { value: itemToEdit._id }})
        let loadedMatrix = loadedData?.tempVariantMatrix || loadedData; // Handle backward compatibility
        let loadedPrimaryCharacteristic = loadedData?.tempPrimaryCharacteristic;

        // console.log("LOADED DATA", loadedData)
        // console.log("BASE MATRIX", loadedMatrix)
        // console.log("LOADED PRIMARY CHARACTERISTIC", loadedPrimaryCharacteristic)

        if (itemToEdit?.variantMatrix) {
            loadedMatrix = mergeVariantMatrixWithSaved(loadedMatrix, itemToEdit.variantMatrix, itemToEdit.characteristics)
        }

        setDependencyForm({
            productId: itemToEdit._id,
            base_price: parseFloat(itemToEdit.price),
            base_width: parseFloat(itemToEdit.width),
            base_height: parseFloat(itemToEdit.height),
            base_depth: parseFloat(itemToEdit.longitude),
            base_weight: parseFloat(itemToEdit.weight),
            characteristics: (itemToEdit?.characteristics)
                .filter((char) => char?.primary !== true)
                .map((char) => ({
                    ...char,
                    enabled: char?.enabled ?? false,
                })),
            dependencyRules: itemToEdit.dependencyRules || [],
            variantMatrix: itemToEdit?.variantMatrix || []
        });

        if (loadedPrimaryCharacteristic) {
            // Merge stored primary characteristic values from itemToEdit with loaded values, matching by valueName
            setPrimaryCharacteristic(prev => ({
                ...prev,
                primaryCharacteristicValues: loadedPrimaryCharacteristic?.primaryCharacteristicValues.map(val => {
                    // Find matching stored value from primaryCharacteristicValues
                    const storedVal = itemToEdit?.primaryCharacteristicValues?.find(
                        stored => stored.valueName === val.valueName
                    );
                    
                    // Find matching stored value from variantMatrix (contains the modifiers)
                    const variantMatrixVal = itemToEdit?.variantMatrix?.find(
                        variant => variant.primaryValueName === val.valueName
                    );
                    
                    return {
                        ...val,
                        // Priority: storedVal -> variantMatrixVal -> default values
                        price_modifier: storedVal?.price_modifier ?? variantMatrixVal?.price_modifier ?? val.price_modifier ?? 0.0,
                        weight_modifier: storedVal?.weight_modifier ?? variantMatrixVal?.weight_modifier ?? val.weight_modifier ?? 0.0,
                        width: storedVal?.width ?? variantMatrixVal?.width ?? val.width ?? 0.0,
                        height: storedVal?.height ?? variantMatrixVal?.height ?? val.height ?? 0.0,
                        depth: storedVal?.depth ?? variantMatrixVal?.depth ?? val.depth ?? 0.0,
                        enabled: storedVal?.enabled ?? val.enabled ?? true
                    };
                    })
                })
            );
        }

        setVariantMatrix(loadedMatrix)
        
        variantMatrixRef.current = loadedMatrix
        setVariantMatrixRefVersion(v => v + 1)

        // console.log("BLOCKING PRODUCT")
        await autoSave({
            productId: itemToEdit._id,
            productVariants: itemToEdit.productVariants || [],
            dependencyRules: itemToEdit.dependencyRules || [],
            variantMatrix: itemToEdit.variantMatrix || []
        })

        setIsLoading(false)
        setIsDataLoaded(true)
    }

    const mergeVariantMatrixWithSaved = (defaultMatrix, savedMatrix) => {
        // console.log("MERGING VARIANT MATRIX WITH SAVED", defaultMatrix, savedMatrix)
        
        return defaultMatrix.map(defaultRow => {
            const savedRow = savedMatrix.find(
                r => r.primaryValueName === defaultRow.primaryValueName
            );

            // console.log("SAVED ROW", savedRow, "DEFAULT ROW", defaultRow)
            if (!savedRow) {
                return {
                    ...defaultRow,
                    characteristics: defaultRow.characteristics.map(defaultChar => ({
                        ...defaultChar,
                        values: defaultChar.values.map(defaultVal => ({
                            ...defaultVal
                        }))
                    }))
                }
            };
    
            return {
                ...defaultRow,
                // Merge top-level modifiers
                price_modifier: savedRow.price_modifier ?? defaultRow.price_modifier,
                weight_modifier: savedRow.weight_modifier ?? defaultRow.weight_modifier,
                width: savedRow.width ?? defaultRow.width,
                height: savedRow.height ?? defaultRow.height,
                depth: savedRow.depth ?? defaultRow.depth,
    
                characteristics: defaultRow.characteristics.map(defaultChar => {
                    const savedChar = savedRow.characteristics?.find(
                        c => c.characteristicId === defaultChar.characteristicId
                    );

                    // console.log("SAVED CHAR", savedChar, "DEFAULT CHAR", defaultChar)
                    if (!savedChar) {
                        return {
                            ...defaultChar,
                            values: defaultChar.values.map(defaultVal => ({
                                ...defaultVal
                            }))
                        }
                    };
    
                    return {
                        ...defaultChar,
                        values: defaultChar.values.map(defaultVal => {
                            const savedVal = savedChar.values?.find(
                                v => v.valueName === defaultVal.valueName
                            );

                            // console.log("SAVED VAL", savedVal, "DEFAULT VAL", defaultVal)
                            if (!savedVal) return defaultVal;
    
                            return {
                                ...defaultVal,
                                enabled: savedVal.enabled ?? defaultVal.enabled,
                                price_modifier: savedVal.price_modifier ?? defaultVal.price_modifier,
                                weight_modifier: savedVal.weight_modifier ?? defaultVal.weight_modifier,
                                width: savedVal.width ?? defaultVal.width,
                                height: savedVal.height ?? defaultVal.height,
                                depth: savedVal.depth ?? defaultVal.depth
                            };
                        })
                    };
                })
            };
        });
    };
    

    const loadBaseProducts = async () => {
        try {
            const result = await getProductsAll();
            // console.log('BASE PRODUCTS', result);

            if (Object.keys(result).length > 0) {
                // TESTING ONLY
                // Keep only the last instance of each product (by _id)
                const deduplicated = Object.values(
                    result.items.reduce((acc, item) => {
                        acc[item._id] = item; // Later entries overwrite earlier ones
                        return acc;
                    }, {})
                );
                setBaseProducts(deduplicated)
                
                // UNCOMMENT BEFORE PUSH
                //setBaseProducts(result.items);
            }
        } catch (error) {
            console.error('Error loading base products:', error);
        }
    };

    const handleBaseProductChange = (e) => {
        const value = e.target.value;

        const selectedProduct = baseProducts.find(item => item._id === value);
        if (!selectedProduct) return;

        // Merge base product dimensions with itemToEdit values
        setDependencyForm({
            productId: value,
            base_price: selectedProduct.price,
            base_width: selectedProduct.width,
            base_height: selectedProduct.height,
            base_depth: selectedProduct.longitude,
            base_weight: selectedProduct.weight,
            characteristics: (itemToEdit?.characteristics || selectedProduct?.characteristics || [])
                .filter((char) => char?.primary !== true)
                .map((char) => ({
                    ...char,
                    enabled: char?.enabled ?? false,
                }))
        });

        const primaryChar = (itemToEdit?.characteristics || selectedProduct?.characteristics || [])
            .find(item => item.primary === true);

        if (!primaryChar) {
            enqueueSnackbar("Registra una característica principal para este producto en la página de Editar Producto.", {
                variant: 'warning'
            });
            onCloseModal();
            return;
        }

        // Set primary characteristic
        const tempPrimaryCharacteristic = {
            primaryCharacteristicName: primaryChar.characteristicName,
            primaryCharacteristicCategory: primaryChar.characteristicCategory,
            primaryCharacteristicCode: primaryChar.code,
            primaryCharacteristicValues: primaryChar.values.map(val => ({
                valueName: val.valueName, 
                code: val.code, 
                enabled: val?.enabled ?? true, 
                price_modifier: val.price_modifier ?? 0.0, 
                weight_modifier: val.weight_modifier ?? 0.0, 
                width: val.width ?? 0.0, 
                height: val.height ?? 0.0, 
                depth: val.depth ?? 0.0
            }))
        }

        // Create variantMatrix with enabled state based on itemToEdit
        const genericChars = (itemToEdit?.characteristics || selectedProduct.characteristics)
            .filter(item => item.primary !== true)
            .map((char) => ({
                ...char,
                values: char.values.map((val) => ({
                    ...val,
                    enabled: val.enabled ?? false,
                    price_modifier: val.price_modifier ?? 0.0,
                    weight_modifier: val.weight_modifier ?? 0.0,
                    width: val.width ?? 0.0,
                    height: val.height ?? 0.0,
                    depth: val.depth ?? 0.0
                }))
            }));

        const tempVariantMatrix = primaryChar.values.map(prim => ({
            primaryValueName: prim.valueName,
            primaryValueCode: prim.code,
            price_modifier: prim.price_modifier ?? 0.0, 
            weight_modifier: prim.weight_modifier ?? 0.0, 
            width: prim.width ?? 0.0, 
            height: prim.height ?? 0.0, 
            depth: prim.depth ?? 0.0,
            characteristics: genericChars
        }));

        setVariantMatrix(tempVariantMatrix);
        setPrimaryCharacteristic(tempPrimaryCharacteristic);
        setCharacteristicActions(genericChars);
        setCurrSelectedRule("");

        if (itemToEdit) {
            return {
                tempVariantMatrix,
                tempPrimaryCharacteristic
            };
        }
    };


    const handleApplyToAllPrimaryValues = (field, newValue) => {

        if (field !== "enabled") {
            newValue = parseFloat(newValue || 0)
        }

        // console.log("UPDATING BASE PRICE")
        setPrimaryCharacteristic(prev => ({
            ...prev,
            primaryCharacteristicValues: prev.primaryCharacteristicValues.map(val => ({
                ...val,
                [field]: newValue
            }))
        }))
    }

    const handleUpdatePrimary = (valueName, field, newValue) => {

        if (field !== "enabled") {
            newValue = parseFloat(newValue || 0)
        }

        // console.log("UPDATING INDIVIDUAL PRIM", valueName, field, newValue)
        setPrimaryCharacteristic(prev => ({
            ...prev,
            primaryCharacteristicValues: prev.primaryCharacteristicValues.map(val => {
                if (val.valueName !== valueName) return val;

                return {
                    ...val,
                    [field]: newValue
                }
            })
        }))
    }

    const updateMatrixCell = (value, rowIdx, charIdx, valIdx, field) => {
        // console.log("UPDATING")

        variantMatrixRef.current = variantMatrixRef.current.map((row, rIdx) => {
          if (rIdx !== rowIdx) return row;
      
          return {
            ...row,
            characteristics: row.characteristics.map((char, cIdx) => {
              if (cIdx !== charIdx) return char;
      
              return {
                ...char,
                values: char.values.map((val, vIdx) => {
                  if (vIdx !== valIdx) return val;
                  return { ...val, [field]: value };
                })
              };
            })
          };
        });
        
        // console.log("REFRESHING MATRIX")
        setVariantMatrixRefVersion(v => v + 1);
    };      

    const handleMatrixAction = (e, charIndex, valIndex, field) => {
        let value;
      
        if (e?.target?.type === "checkbox") {
          value = e.target.checked;
        } else {
          value = parseFloat(e?.target?.value) || 0;
        }
      
        // console.log("UPDATING ACTION", { e, charIndex, valIndex, field, value });
      
        // ✅ Update characteristicActions
        setCharacteristicActions(prev => {
          const updatedActions = [...prev];
          const target = updatedActions[charIndex]?.values?.[valIndex];
          if (target) {
            updatedActions[charIndex] = {
              ...updatedActions[charIndex],
              values: updatedActions[charIndex].values.map((v, idx) =>
                idx === valIndex ? { ...v, [field]: value } : v
              ),
            };
          }
          return updatedActions;
        });
      
        // ✅ Bulk update across all rows in variantMatrixRef
        variantMatrixRef.current = variantMatrixRef.current.map(item => {
          if (item.characteristics?.[charIndex]?.values?.[valIndex]) {
            item.characteristics[charIndex].values[valIndex][field] = value;
          }
          return item;
        });
      
        setVariantMatrixRefVersion(v => v + 1); // trigger rerender
      };
      
    

    const handleCreateRule = () => {
        const newRule = {
            _id: uuidv4(),
            title: "Nueva Regla",
            primary: [],
            if: [],
            then: [],
        }

        setDependencyForm(prev => {
            // console.log("CREATING RULE", prev)
            return {
                ...prev,
                dependencyRules: [...(prev.dependencyRules || []), newRule]
            }
        })

        setCurrSelectedRule(newRule)
    }

    const updateCurrSelectedRule = (e, field) => {
        const value = e.target.value;

        setDependencyForm(prev => {
            // console.log("UPDATING RULE", prev)
            const updatedRules = prev.dependencyRules.map(rule => {
                if (rule._id === currSelectedRule._id) {
                    return {
                        ...rule,
                        [field]: value
                    };
                }

                return rule
            })

                // Update current rule
            setCurrSelectedRule(
                updatedRules.find(item => item._id === currSelectedRule._id)
            )

            return {
                ...prev,
                dependencyRules: updatedRules
            }
        })
    }

    const renderRuleCharacteristicOptions = useMemo(() => {
        // console.log("RENDER RULE CHAR OPTIONS", variantMatrix, currSelectedRule)

        if (!variantMatrix || !currSelectedRule?.primary?.length) return [];

        // Get all variants with matching primary values
        const matchingVariants = variantMatrix.filter(
            variant => currSelectedRule.primary.includes(variant.primaryValueName)
        );

        // console.log("MATHC VAR", matchingVariants)

        const characteristicMap = {};

        matchingVariants.forEach(variant => {
            (variant.characteristics || []).forEach(({ characteristicName, characteristicCategory, characteristicId, values }) => {
                if (!characteristicId) return;

                // Get only enabled value names
                const enabledValues = new Set(
                    values.filter(v => v.enabled).map(v => v.valueName)
                );

                if (!characteristicMap[characteristicId]) {
                    // First occurrence — initialize with full set
                    characteristicMap[characteristicId] = {
                        characteristicName,
                        characteristicCategory,
                        values: enabledValues
                    };
                } else {
                    // Intersection: keep only values already present in the set
                    const currentSet = characteristicMap[characteristicId].values;
                    characteristicMap[characteristicId] = {
                        characteristicName,
                        characteristicCategory,
                        values: new Set(
                            [...currentSet].filter(value => enabledValues.has(value))
                        )
                    };
                }
            });
        });

        // Convert to array for rendering (optional)
        const result = Object.entries(characteristicMap).map(([characteristicId, {characteristicName, characteristicCategory, values}]) => ({
            characteristicId,
            characteristicName,
            characteristicCategory,
            values: Array.from(values),
        }));

        // console.log("Processed INTERSECTED characteristics:", result);

        // Filter only characteristics with values
        return result.filter(item => item.values.length > 0) || []
    }, [variantMatrix, currSelectedRule?.primary]);

    const onNewDependency = () => {
        setCurrSelectedRule(prev => {
            if (!prev) return prev;

            const newThen = {
                characteristicId: "",
                characteristicName: "",
                characteristicCategory: "",
                values: []
            }

            const updatedThens = [...(prev.then || []), newThen];

            setDependencyForm(dPrev => {
                // console.log("NEW DEP", dPrev)
                const updatedRules = dPrev.dependencyRules.map(rule => {
                    if (rule._id === prev._id) {
                        return {
                            ...rule,
                            then: updatedThens
                        }
                    }

                    return rule;
                })

                return {
                    ...dPrev,
                    dependencyRules: updatedRules
                }
            })

            return {
                ...prev,
                then: updatedThens
            }
        })
    }

    const onSelectRuleIfItem = ({ mode = "characteristic", payload }) => {
        setCurrSelectedRule(prev => {
            if (!prev) return prev;

            if (mode === "characteristic") {
                // console.log("IS CHAR", payload)

                const targetId = payload.characteristicId;
                const exists = prev.if.find(item => item.characteristicId === targetId);
                if (exists) {
                    // NOTIFY - characteristic in list.
                    enqueueSnackbar("Elige una característica que no esté en la lista.", {
                        variant: 'warning'
                    });
                    return prev
                };

                // console.log("NOT EXIST")

                const options = renderRuleCharacteristicOptions;
                const selectedCharacteristic = options.find(item => item.characteristicId === targetId);

                if (!selectedCharacteristic) return prev;

                const updatedIf = [
                    ...(prev.if || []),
                    {
                        characteristicId: selectedCharacteristic.characteristicId,
                        characteristicName: selectedCharacteristic.characteristicName,
                        values: []
                    }
                ];

                setDependencyForm(dPrev => ({
                    ...dPrev,
                    dependencyRules: dPrev.dependencyRules.map(rule =>
                        rule._id === prev._id ? { ...rule, if: updatedIf } : rule
                    )
                }));

                return {
                    ...prev,
                    if: updatedIf
                };
            }

            if (mode === "value") {
                const { characteristicId, valueName } = payload;
                const targetChar = prev.if.find(item => item.characteristicId === characteristicId);
                if (!targetChar) return prev;

                // Prevent duplicate values
                const alreadyExists = targetChar.values.find(v => v.valueName === valueName);
                if (alreadyExists) {
                    // NOTIFY - value in list.
                    enqueueSnackbar("Elige un valor que no esté en la lista.", {
                        variant: 'warning'
                    });
                    return prev
                };

                const updatedIf = prev.if.map(item =>
                    item.characteristicId === characteristicId
                        ? {
                            ...item,
                            values: [...item.values, valueName]
                        }
                        : item
                );

                setDependencyForm(dPrev => ({
                    ...dPrev,
                    dependencyRules: dPrev.dependencyRules.map(rule =>
                        rule._id === prev._id ? { ...rule, if: updatedIf } : rule
                    )
                }));

                return {
                    ...prev,
                    if: updatedIf
                };
            }

            return prev;
        });
    };

    const onSelectedThen = ({ payload }) => {
        // console.log("ON SELECTED THEN", payload)
        if (!payload?.characteristicId) return;

        const { characteristicId, index, valueName } = payload;
        // console.log("CURR RULE", currSelectedRule)

        const { characteristicName, characteristicCategory } = renderRuleCharacteristicOptions.find(item => item.characteristicId === characteristicId)

        setCurrSelectedRule(prev => {
            if (!prev) return prev;

            // Check if characteristic in THEN
            const charExists = prev.then.some(item => item.characteristicId === characteristicId)
            if (charExists && !valueName) {
                // console.log("Adding char that exists")

                // NOTIFY - characteristic in list.
                enqueueSnackbar("Elige una característica que no esté en la lista.", {
                    variant: 'warning'
                });
                return prev
            };

            // Update current then
            const updatedThen = prev.then.map((item, pindex) => {
                if (pindex === index) {
                    const currValues = item.values || []

                    const isSameCharacteristic = item.characteristicId === characteristicId;

                    if (valueName) {
                        const valueExists = currValues.find(val => val.valueName === valueName)
                        if (valueExists) {
                            // NOTIFY - value in list
                            enqueueSnackbar("Elige un valor que no esté en la lista.", {
                                variant: 'warning'
                            });
                            return item
                        }

                        return {
                            ...item,
                            characteristicId: characteristicId,
                            characteristicName: characteristicName,
                            characteristicCategory: characteristicCategory,
                            values: isSameCharacteristic
                                ? [...currValues, {
                                    valueName,
                                    price_modifier: 0.0,
                                    weight_modifier: 0.0,
                                    width: 0.0,
                                    height: 0.0,
                                    depth: 0.0
                                }]
                                : [{
                                    valueName,
                                    price_modifier: 0.0,
                                    weight_modifier: 0.0,
                                    width: 0.0,
                                    height: 0.0,
                                    depth: 0.0
                            }]
                        }
                    }
                    
                    return {
                        ...item,
                        characteristicId: characteristicId,
                        characteristicName: characteristicName,
                        values: isSameCharacteristic ? [...currValues] : []
                    }
                }
                return item
            })

            // Update dependencyForm
            setDependencyForm(dPrev => {
                if (!dPrev) return dPrev;

                const updatedRule = dPrev.dependencyRules.map(rule => {
                    if (rule._id === currSelectedRule._id) {
                        return {
                            ...rule,
                            then: updatedThen
                        }
                    }
                    return rule
                })

                return {
                    ...dPrev,
                    dependencyRules: updatedRule
                }
            })

            return {
                ...prev,
                then: updatedThen
            }
        })
    }

    const onChangeDependencyValue = ({ payload }) => {
        // console.log("UPDATING THEN VALUE", payload)

        const { type, characteristicId, target, value } = payload

        setCurrSelectedRule(prev => {
            if (!prev?.then) return prev;

            // console.log(prev)
            const updatedThen = prev.then.map(item => {
                if (item.characteristicId !== characteristicId) return item

                return {
                    ...item,
                    values: item.values.map(v => {
                        if (v.valueName !== target) return v

                        return {
                            ...v,
                            [type]: value
                        }
                    })
                }
            })

            // Update dependencyForm
            setDependencyForm(dPrev => {
                if (!dPrev) return dPrev;

                const updatedRule = dPrev.dependencyRules.map(rule => {
                    if (rule._id === currSelectedRule._id) {
                        return {
                            ...rule,
                            then: updatedThen
                        }
                    }
                    return rule
                })

                return {
                    ...dPrev,
                    dependencyRules: updatedRule
                }
            })

            return {
                ...prev,
                then: updatedThen
            }
        })
    }

    const onDeleteRule = () => {
        setDependencyForm(prev => {
            const filteredRules = prev.dependencyRules?.filter(rule => rule._id !== currSelectedRule._id)

            return {
                ...prev,
                dependencyRules: filteredRules
            }
        })  
        setCurrSelectedRule("")
        
        setOpenDeleteModal(false)
    }

    const onDeleteIf = () => {
        // console.log("DELETE CONTEXT", deleteContext);

        if (!deleteContext?.payload?.characteristicId) return;

        const targetCharId = deleteContext.payload.characteristicId;
        const targetValueName = deleteContext.payload.valueName;

        // console.log("TARGET", targetValueName)

        setDependencyForm(prev => {
            const updatedRules = prev.dependencyRules.map(rule => {
                if (rule._id !== currSelectedRule._id) return rule;

                const updatedIf = rule.if.map(char => {
                    if (char.characteristicId !== targetCharId) return char;

                    if (!targetValueName) {
                        // No valueName provided → delete entire characteristic
                        return null;
                    }

                    // console.log("TARGET CHAR", char)
                    // Filter out the target value from the values array
                    const updatedValues = char.values.filter(val => val !== targetValueName);
                    return { ...char, values: updatedValues };
                }).filter(Boolean); // Remove nulls if a characteristic was deleted

                return { ...rule, if: updatedIf };
            });

            const updatedCurrent = updatedRules.find(rule => rule._id === currSelectedRule._id);
            setCurrSelectedRule(updatedCurrent);

            return {
                ...prev,
                dependencyRules: updatedRules
            };
        });
    };

    const onDeleteThen = () => {
        // console.log("DELETING THEN", deleteContext)
        if (!deleteContext?.payload) return;

        const { type, payload } = deleteContext
        // console.log("TYPE", type)

        setCurrSelectedRule(prev => {
            if (!prev?.then) return prev; 
            
            let updatedThens
            if (payload?.index !== undefined) {
                const targetIndex = payload.index;
                // console.log("TARGET THEN DELETE", targetIndex)
                
                updatedThens = prev.then.filter((_, index) => index !== targetIndex)

            } else if (payload?.characteristicId !== undefined && payload?.valueName !== undefined) {
                // console.log("REMOVE VALUE THEN")
                const { characteristicId, valueName } = payload;

                updatedThens = prev.then.map(item => {
                    if (item.characteristicId !== characteristicId) return item

                    return {
                        ...item,
                        values: item.values.filter(v => v.valueName !== valueName)
                    }
                })
            }
            
            setDependencyForm(dPrev => {
                const updatedRules = dPrev.dependencyRules.map(rule => {
                    if (rule._id === prev._id) {
                        return {
                            ...prev,
                            then: updatedThens
                        }
                    }
                    return rule;
                })

                return {
                    ...dPrev,
                    dependencyRules: updatedRules
                }
            })

            return {
                ...prev,
                then: updatedThens
            }
        })
    }

    const onDeleteVariant = () => {
        if (!deleteContext?.payload) return

        const { variantId } = deleteContext.payload
        // console.log("VARS", dependencyForm.generatedVariants, "VAR TO DELETE", variantId)

        setDependencyForm(prev => {
            const updatedVariants = prev.generatedVariants.filter(v => v._id !== variantId)

            return {
                ...prev,
                generatedVariants: updatedVariants
            }
        })
        // console.log("Variant removed")
    }

    const deleteActions = {
        "rule": onDeleteRule,
        "characteristic-if": onDeleteIf,
        "value-if": onDeleteIf,
        "then": onDeleteThen,
        "variant": onDeleteVariant,
    };

    const handleDeleteConfirm = () => {
        const actionFn = deleteActions[deleteContext.type]
        if (!actionFn) return

        actionFn()
        setDeleteContext(null)
        setOpenDeleteModal(false)
    }

    const handleGenerateVariants = async () => {
        if (!dependencyRules) {
            // NOTIFY - Define dependency rules
            // console.log("NO RULES")
            enqueueSnackbar("Define las reglas de dependencia antes de generar las variantes.", {
                variant: 'warning'
            });
            return
        }

        if (isLoading) return

        setIsLoading(true)

        const resp = await productVariantsGenerate({productId, primaryCharacteristicValues, variantMatrix, dependencyForm})
        // console.log(resp)

        if (resp) {
            setDependencyForm(prev => {
                return {
                    ...prev,
                    generatedVariants: resp.result
                }
            })
        } else {
            enqueueSnackbar(
                "Sucedió un error al generar las variantes.",
                {variant: "error"}
            )
        }
        setIsLoading(false)
    }

    const validateVariantMatrix = () => {
        let msg;

        // console.log("VALIDATE VARIANT MATRIX", characteristics)

        // Skip if product only has primary characteristic
        if (!characteristics || characteristics.length === 0 || (characteristics.length === 1 && characteristics[0].primary)) {
            return {
                isValid: true,
                msg: ""
            }
        }

        const hasEnabledValue = variantMatrix?.some(primaryChar => {
            return primaryChar.characteristics?.some(char => {
                return char.values?.some(val => val.enabled)
            })
        })

        if (!hasEnabledValue) {
            return {
                isValid: false,
                msg: "Habilita al menos 1 valor de las características para continuar."
            }
        }

        return {
            isValid: true,
            msg: ""
        }
    }

    const validateDependencyRules = () => {
        let msg;

        const invalidRules = dependencyForm.dependencyRules?.some(rule => {
            if (!rule.title?.trim()) {
                msg = "Ingresa el titulo de todas las reglas.";
                return true;
            }
            if (!rule.primary || rule.primary.length === 0) {
                msg = "Registra los valores principales de todas las reglas.";
                return true;
            }
            if (!rule.if || rule.if.length === 0) {
                msg = "Registra los datos de la sección SÍ de todas las reglas.";
                return true;
            }
            if (!rule.then || rule.then.length === 0) {
                msg = "Registra los datos de la sección ENTONCES de todas las reglas.";
                return true;
            }

            const ifHasMissingValues = rule.if.some(item => !item.values || item.values.length === 0);
            const thenHasMissingValues = rule.then.some(item => !item.values || item.values.length === 0);

            // console.log("MISSING VALUES", ifHasMissingValues, thenHasMissingValues)

            if (ifHasMissingValues || thenHasMissingValues) {
                msg = "Registra los valores de las secciones de SÍ y ENTONCES de todas las reglas."
                return true
            }

            return false
        })

        if (invalidRules) {
            return {
                isValid: false,
                msg
            }
        }

        return {
            isValid: true,
            msg
        };
    }

    const validateGeneratedVariants = () => {
        if (!dependencyForm.generatedVariants) {
            return {
                isValid: false,
                msg: "No hay variantes generadas. Presiona el botón para generar variantes o ajusta las reglas."
            };
        }

        return {
            isValid: true,
            msg: ""
        }
    }

    const validationMap = {
        1: validateVariantMatrix,
        2: validateDependencyRules,
        // 4: validateGeneratedVariants
    }

    const stepValidation = () => {
        let result = { isValid: true, msg: "" };

        const validationFn = validationMap[activeTab]

        if (validationFn) {
            // console.log("Validating Tab:", activeTab);
            result = validationFn()
        }

        if (!result.isValid) {
            enqueueSnackbar(result.msg, { variant: 'error' });
            return false
        }

        return true
    }

    const handleParsePriceCSV = () => {
        // console.log("PARSING PRICE CSV")
        // Create CSV encoding string
        const csvData = 'data:text/csv;charset=utf-8,' + '\uFEFF'
        const rows = []

        // console.log("MATRIX SIZE", variantMatrix.length)

        // console.log("CHARACTERISTICS", characteristics)

        // Create Header ROW
        rows.push(itemToEdit?.productName || "N/A")
        rows.push("Precio Base," + `$${dependencyForm.base_price}`)
        rows.push(primaryCharacteristicName + "," + primaryCharacteristicValues.map(p => escapeComma(p.valueName)).join(","))
        rows.push("," + primaryCharacteristicValues.map(p => `$${p.price_modifier}`).join(","))

        rows.push("")
        
        // Iterate characteristics
        for (let i = 0; i < characteristics.length; i++) {
            // Add characteristic name
            rows.push(escapeComma(characteristics[i].characteristicName))

            // Skip values if characteristic does not modify price
            if (characteristics[i].characteristicCategory !== "price_only" && characteristics[i].characteristicCategory !== "price_and_dimensions") {
                continue;
            }

            // Iterate prices for characteristic value in matrix
            for (let j = 0; j < characteristics[i].values.length; j++) {
                const valueRow = []
                const valueName = escapeComma(characteristics[i].values[j].valueName)

                valueRow.push(valueName)
                for (let k = 0; k < variantMatrixRef.current.length; k++) {
                    const matrixValue = variantMatrixRef.current[k].characteristics[i].values[j]

                    if (matrixValue.enabled) {
                        valueRow.push("$" + matrixValue.price_modifier)
                    } else {
                        valueRow.push("N/A")
                    }
                }
                rows.push(valueRow.join(","))
            }
            rows.push("")
        }

        rows.push("\n", "Precios Por Regla")

        // Iterate dependency rules
        dependencyRules?.forEach(rule => {
            rows.push(escapeComma(rule.title))

            rule.if.forEach(ifChar => {
                const ifCharName = escapeComma(ifChar.characteristicName)
                const ifCharVals = ifChar.values.map(v => v).join("/")
                
                rows.push(ifCharName + " - " + ifCharVals)
            })

            rows.push("******* PRECIOS ********")
            rule.then.forEach(thenChar => {
                rows.push(escapeComma(thenChar.characteristicName))

                thenChar.values.forEach(val => {
                    const valueRow = []
                    // Now build rows for each option inside thenChar.values
                    valueRow.push(escapeComma(val.valueName)); 
                
                    // Prices across primaries
                    primaryCharacteristicValues.forEach(primary => {
                        if (rule.primary.includes(primary.valueName)) {
                        valueRow.push(`$${val.price_modifier.toFixed(2)}`);
                        } else {
                        valueRow.push("N/A");
                        }
                    });
                    rows.push(valueRow.join(","))
                });
                rows.push("")
            });

            rows.push("")
        });

        const fileName = "Resumen de Precios - " + itemToEdit?.productName || "N/A" + " - " + new Date().toLocaleDateString() + ".csv"
        const encodedUri = encodeURI(csvData + rows.join('\n'));
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const flattenVariant = (variant) => {
        const primaryValue = variant.primary ? { ...variant.primary } : null;
        return {
            ...variant,
            longitude: variant.totals.longitude,
            width: variant.totals.width,
            height: variant.totals.height,
            weight: variant.totals.weight,
            priceModifier: variant.totals.priceModifier,
            baseLongitude: variant.base_data.baseLongitude,
            baseWidth: variant.base_data.baseWidth,
            baseHeight: variant.base_data.baseHeight,
            baseWeight: variant.base_data.baseWeight,
            priceBase: variant.base_data.priceBase,
        };
    };

    const processProductConfig = () => {
        let postProcessedVariants = []
        if (dependencyForm.generatedVariants) {
            for (const v of dependencyForm.generatedVariants) {
                postProcessedVariants.push(flattenVariant(v))
            }
        }

        // Update primary value weight, price and dimensions in variant matrix
        const updatedVariantMatrix = variantMatrixRef.current.map(item => {
            const matchingPrimary = primaryCharacteristicValues.find(p => p.valueName === item.primaryValueName);

            // console.log("MATCHING PRIMARY", matchingPrimary, "ITEM", item)

            if (matchingPrimary) {
                return {
                    ...item,
                    depth: matchingPrimary.depth,
                    width: matchingPrimary.width,
                    height: matchingPrimary.height,
                    weight_modifier: matchingPrimary.weight_modifier,
                    price_modifier: matchingPrimary.price_modifier,
                    characteristics: item.characteristics.map(char => ({
                        ...char,
                        values: char.values.map(v => ({ ...v })) // deep copy values
                    }))
                }
            }
            return item;
        });

        return {
            productId,
            productVariants: postProcessedVariants,
            dependencyRules,
            variantMatrix: JSON.parse(JSON.stringify(updatedVariantMatrix))
        }
    }

    const onSubmitVariants = async (confirmPublished = false) => {
        // console.log("POSTING VARIANTS")

        clearInterval(autoSaveIntervalIdRef.current)

        if (isLoading) {
            enqueueSnackbar(
                "La configuración ya está siendo guardada.", 
                { variant: 'warning' }
            );
            return
        };

        setIsLoading(true);

        enqueueSnackbar(
            "Guardando cambios. Espera un momento.", 
            { variant: 'warning' }
        );

        try {
            const formData = processProductConfig()
            // console.log("SAVE FORM DATA", formData)

            const resp = await productVariantsCreate({...formData, isPublished: confirmPublished});

            if (resp.result) {
                enqueueSnackbar("Cambios guardados exitosamente.", { variant: 'success' });
                onConfirmed()
                onCloseModal()
            } else {
                enqueueSnackbar("Sucedió un error al registrar los cambios.", { variant: 'error' });
            }

        } catch (e) {
            console.error("Failed to create variants", e)
            enqueueSnackbar("Sucedió un error al registrar los cambios.", { variant: 'error' });
        }

        setIsLoading(false);
        setOpenConfirmModal(false)
        setOpenPublishModal(false)
    }
    

    return (
        <Modal
            disableEscapeKeyDown
            slotProps={{backdrop: {onClick: null}}}
            open={openModal}
            onClose={onCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
                backdropFilter: 'blur(2px)',
                BackdropProps:{
                onClick: null
                },
                '& .MuiModal-backdrop': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)'
                },
            }}
        >
            <Box sx={{ maxHeight: "900px", overflowY: "scroll", ...styleModal}}>
                <Box sx={{display: 'flex', justifyContent: "flex-end", width:'100%', px: '1.25rem' }}>
                    <IconButton sx={{ padding: 0}} onClick={onCloseModal}>
                        <CancelIcon sx={{color: '#FC581F', fontSize:'1.8rem'}}/>
                    </IconButton>
                </Box>
                <Box sx={{ display:'flex', flexDirection: 'column', px: {xs: '1.25rem', md:'3.125rem'}, gap:'2.5rem' }}>
                    <TitleText title={"CREACIÓN DE DEPENDENCIAS"} customStyle={{ py: 0 }}/>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        width: "100%",
                        gap: 2
                    }}>
                        {tabs.map((item, index) => (
                            <Box 
                                key={index}
                                sx={{
                                    // borderBottom: 1,
                                    borderBottomWidth: "0.3rem",
                                    borderBottomColor: item.step === activeTab ? '#FC581F' : '#303030',
                                    px: 2
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#2C2C2C",
                                        fontSize: "1rem",
                                        overflowWrap: "break-word",
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            gap: 4
                        }}
                    >
                        <FormGroup>
                            <FormLabel sx={formLabelStyle}>
                                PRODUCTO BASE
                            </FormLabel>
                            <Select
                                value={productId || ""}
                                disabled={!!itemToEdit || activeTab !== 1}
                                onChange={handleBaseProductChange}
                            >
                                <MenuItem value={""} disabled>Producto Base</MenuItem>
                                {baseProducts && baseProducts.map((item, index) => (
                                    <MenuItem key={index} value={item._id}>{item.productName}</MenuItem>
                                ))}
                            </Select>
                        </FormGroup> 

                        {productId && activeTab == 1 &&
                            <CharacteristicDependencyValuesTable
                                itemToEdit={itemToEdit}
                                characteristicActions={characteristicActions}
                                primaryCharacteristicName={primaryCharacteristicName}
                                primaryCharacteristicValues={primaryCharacteristicValues}
                                variantMatrix={variantMatrixRef.current}
                                handleUpdatePrimary={handleUpdatePrimary}
                                handleApplyToAllPrimaryValues={handleApplyToAllPrimaryValues}
                                sharedPriceModifier={sharedPriceModifier}
                                setSharedPriceModifier={setSharedPriceModifier}
                                sharedWeightModifier={sharedWeightModifier}
                                setSharedWeightModifier={setSharedWeightModifier}
                                sharedDepth={sharedDepth}
                                setSharedDepth={setSharedDepth}
                                setSharedWidth={setSharedWidth}
                                sharedWidth={sharedWidth}
                                setSharedHeight={setSharedHeight}
                                sharedHeight={sharedHeight}
                                characteristics={characteristics}
                                dependencyForm={dependencyForm}
                                updateMatrixCell={updateMatrixCell}
                                handleMatrixAction={handleMatrixAction}
                            />
                        }
                    
                        {activeTab === 2 && (
                            <CharacteristicDependencyRuleForm
                                dependencyRules={dependencyRules}
                                setCurrSelectedRule={setCurrSelectedRule}
                                currSelectedRule={currSelectedRule}
                                updateCurrSelectedRule={updateCurrSelectedRule}
                                onSelectRuleIfItem={onSelectRuleIfItem}
                                onNewDependency={onNewDependency}
                                onSelectedThen={onSelectedThen}
                                primaryCharacteristicValues={primaryCharacteristicValues}
                                setDeleteContext={setDeleteContext}
                                setOpenDeleteModal={setOpenDeleteModal}
                                handleCreateRule={handleCreateRule}
                                renderRuleCharacteristicOptions={renderRuleCharacteristicOptions}
                            />
                        )}
                    
                        {activeTab === 3 && (
                            <CharacteristicDependencyRuleModifiers
                                dependencyRules={dependencyRules}
                                setCurrSelectedRule={setCurrSelectedRule}
                                currSelectedRule={currSelectedRule}
                                onChangeDependencyValue={onChangeDependencyValue}
                            />
                        )}
                        {!isLoading && activeTab == 4 && (
                            <>
                                <CharacteristicDependencyPriceCSV 
                                    onClick={handleParsePriceCSV}
                                />
                                {/* <ProductVariantSummary
                                    dependencyForm={dependencyForm}
                                    setDeleteContext={setDeleteContext}
                                    setOpenDeleteModal={setOpenDeleteModal}
                                    handleGenerateVariants={handleGenerateVariants}
                                    isLoading={isLoading}
                                /> */}
                            </>
                        )}
                    {isLoading && (
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center"
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "3rem",
                                    fontWeight: "bold"
                                }}
                            >
                                Cargando...
                            </Typography>  
                        </Box>
                    )}
                    <Box 
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            flexWrap: "nowrap",
                            width: "100%"
                        }}
                    >
                        <ButtonStyled 
                            text={
                                <Box 
                                    sx={{ 
                                        display: "flex", 
                                        flexDirection: "row", 
                                        justifyContent: "center", 
                                        width: "100%", 
                                        flexWrap: "nowrap", 
                                        gap: 2
                                    }}
                                >
                                    <ArrowBackIcon />
                                    <Typography
                                        sx={{
                                            fontSize: "1rem",
                                            overflowWrap: "break-word",
                                        }}
                                    >
                                        Regresar
                                    </Typography>  
                                </Box>
                            } 
                            customStyle={{ 
                                backgroundColor: "white", 
                                color: "#A1A1A1", 
                                borderColor: "#A1A1A1", 
                                border: 1,
                            }} 
                            primary={false}
                            isDisabled={ activeTab !== 1 ? false : true} 
                            handleClick={() => {
                                if (activeTab > 0) setActiveTab(activeTab - 1)
                            }} 
                            />
                        {activeTab !== 4 ? (
                            <ButtonStyled 
                                    text={
                                        <Box 
                                            sx={{ 
                                                display: "flex", 
                                                flexDirection: "row", 
                                                justifyContent: "center", 
                                                width: "100%", 
                                                flexWrap: "nowrap", 
                                                gap: 2
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: "1rem",
                                                    overflowWrap: "break-word",
                                                }}
                                            >
                                                Continuar
                                            </Typography>  
                                            <ArrowForwardIcon />
                                        </Box>
                                    } 
                                    handleClick={() => {
                                        if (activeTab < tabs.length) {
                                            const canStep = stepValidation()
                                            if (canStep) setActiveTab(activeTab + 1)
                                        }
                                    }} 
                                />
                            ) : (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        flexWrap: "nowrap",
                                        gap: 2
                                    }}
                                >
                                    <ButtonStyled 
                                        text={
                                            <Box 
                                                sx={{ 
                                                    display: "flex", 
                                                    flexDirection: "row", 
                                                    justifyContent: "center", 
                                                    width: "100%", 
                                                    flexWrap: "nowrap", 
                                                    gap: 2
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "1rem",
                                                        overflowWrap: "break-word",
                                                    }}
                                                >
                                                    Guardar
                                                </Typography>  
                                                <CheckIcon />
                                            </Box>
                                        } 
                                        isDisabled={isLoading}
                                        handleClick={() => {
                                            setOpenConfirmModal(true)
                                        }} 
                                    />
                                    <ButtonStyled 
                                        text={
                                            <Box 
                                                sx={{ 
                                                    display: "flex", 
                                                    flexDirection: "row", 
                                                    justifyContent: "center", 
                                                    width: "100%", 
                                                    flexWrap: "nowrap", 
                                                    gap: 2
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "1rem",
                                                        overflowWrap: "break-word",
                                                    }}
                                                >
                                                    Guardar y Publicar
                                                </Typography>  
                                                <PublishIcon />
                                            </Box>
                                        } 
                                        isDisabled={isLoading}
                                        handleClick={() => {
                                            setOpenPublishModal(true)
                                        }} 
                                    />
                                </Box>
                            )
                        }
                    </Box>
                    </Box>
                </Box>
                <DeleteModal 
                    title={"¿Estás seguro que deseas borrar?"}
                    confirmButtonText={"Confirmar"}
                    openModal={openDeleteModal}
                    onCloseModal={() => setOpenDeleteModal(false)}
                    onConfirmed={handleDeleteConfirm}
                />
                <DeleteModal 
                    title={"¿Estás seguro que deseas guardar la configuración del producto?"}
                    confirmButtonText={"Confirmar"}
                    openModal={openConfirmModal}
                    onCloseModal={() => setOpenConfirmModal(false)}
                    onConfirmed={() => onSubmitVariants(false)}
                    isDisabled={isLoading}
                />
                <DeleteModal 
                    title={"¿Estás seguro que deseas guardar la configuración del producto y publicarlo?"}
                    confirmButtonText={"Confirmar"}
                    openModal={openPublishModal}
                    onCloseModal={() => setOpenPublishModal(false)}
                    onConfirmed={() => onSubmitVariants(true)}
                    isDisabled={isLoading}
                />
            </Box>
        </Modal>
    )
}

export default CharacteristicDependencyModal
